import { DocumentType } from './document.interfaces';

export const documentTypeLabels = {
  [DocumentType.Payslip]: $localize`Payslip`,
  [DocumentType.ExpenseNote]: $localize`Expense note`,
  [DocumentType.HealthInsuranceCertificate]: $localize`Health insurance certificate`,
  [DocumentType.TaxCertificate]: $localize`Tax certificate`,
  [DocumentType.CriminalRecord]: $localize`Criminal record`,
} as const satisfies { [k in DocumentType]: string };
